import CmsImage from '@/cmsComponents/CmsImage';
import { parseAndFormatDate } from '@/utils/dateHelper';
import { pushGtmEvent } from '@/utils/gtm';
import { PATH } from 'constants/path';
import Link from 'next/link';
import { IArticleSummary } from 'types/cms';

import Calendar from 'components/JobInformation/icons/calendar.svg';

import styles from './GuideCard.module.scss';

export interface GuideCardProps {
  article: IArticleSummary;
}

export const GuideCard = ({ article }: GuideCardProps) => (
  <Link
    prefetch={false}
    href={`${PATH.ARTICLES}/${article.slug}`}
    className={styles.guideCard}
    onClick={() =>
      pushGtmEvent({
        event: 'article_click',
        element: 'Read more',
        article_title: article.title,
        article_category: article.article_category?.name ?? '',
        article_url: `${PATH.ARTICLES}/${article.slug}`,
      })
    }
  >
    <div className={styles.imageWrapper}>
      {article.cover && (
        <CmsImage
          imageProps={article.cover}
          altText={article.title}
          format="medium"
          layout="fill"
          objectFit="cover"
          className={styles.image}
          sizes="(max-width: 959px) 100vw, 33vw"
        />
      )}
    </div>
    <div className={styles.content}>
      <div className={styles.meta}>
        {article.article_category?.name && (
          <p className={styles.category}>{article.article_category.name.toUpperCase()}</p>
        )}
        <div className={styles.publishedDate}>
          <Calendar className={styles.calendarIcon} />
          <p>{parseAndFormatDate(article.published_date, 'DD MMM YYYY')}</p>
        </div>
      </div>
      <p className={styles.title}>{article.title}</p>
      <p className={styles.readMore}>Read more</p>
    </div>
  </Link>
);

export default GuideCard;
